import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, Fragment as _Fragment, withModifiers as _withModifiers, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["title"]
const _hoisted_2 = ["src"]
const _hoisted_3 = {
  key: 1,
  class: "user-trigger__avatar user-trigger__avatar--liter"
}
const _hoisted_4 = { class: "user-dd" }
const _hoisted_5 = { class: "user-dd__content" }
const _hoisted_6 = { class: "user-dd__name" }
const _hoisted_7 = { class: "user-dd__email" }
const _hoisted_8 = { class: "user-dd__content" }
const _hoisted_9 = {
  key: 0,
  class: "user-dd__status-text"
}
const _hoisted_10 = {
  key: 1,
  class: "user-dd__status-placeholder"
}
const _hoisted_11 = { class: "user-dd__status-actions" }
const _hoisted_12 = { class: "user-dd__content" }
const _hoisted_13 = { class: "user-dd__text" }

import {
	computed,
	ref,
	watch
} from "vue"
import { useRouter } from "vue-router"
import AppResizableDropdown from "@/components/ui-kit/dropdown/AppResizableDropdown.vue"
import AppCustomTextarea from "@/components/ui-kit/textarea/AppCustomTextarea.vue"
import AppIcon from "@/components/ui-kit/icon/AppIcon.vue"
import AppButton from "@/components/ui-kit/button/AppButton.vue"
import { workerStore } from "@/store/worker"
import { headerStore } from "@/store/header"
import { clearSession } from "@/composables/useSession"
import { resolvePhotoUrl } from "@/utils/urlHelpers"


export default /*@__PURE__*/_defineComponent({
  __name: 'HeaderUserDropdown',
  setup(__props) {

const router = useRouter()

const wStore = workerStore()
const hStore = headerStore()

const dropdownRef = ref<InstanceType<typeof AppResizableDropdown> | null>(null)

const profile = computed(() => wStore.workerProfile)

const onOpenSettings = () => {
	dropdownRef.value?.close()
	if (router.currentRoute.value.path !== '/settings') {
		router.push('/settings')
	}
}

const avatarLiter = computed(() => {
	const liter = profile.value?.PhotoLiter?.trim()
	if (liter) return liter
	const name = profile.value?.Name?.trim()
	return name ? name.charAt(0).toUpperCase() : '?'
})

const editingStatus = ref(false)
const draftStatus = ref<string>('')

watch(profile, (val) => {
	if (!editingStatus.value) {
		draftStatus.value = val?.Status ?? ''
	}
}, { immediate: true })

const onEditStatus = () => {
	draftStatus.value = profile.value?.Status ?? ''
	editingStatus.value = true
}

const onCancelStatus = () => {
	editingStatus.value = false
	draftStatus.value = profile.value?.Status ?? ''
}

const onSaveStatus = async () => {
	try {
		await wStore.setStatus(draftStatus.value)
		editingStatus.value = false
	} catch (e) {
		console.error('[HeaderUserDropdown] save status failed', e)
	}
}

const soundLabel = computed(() => hStore.enableSound ? 'Звук включен' : 'Звук выключен')

const soundIconName = computed(() => hStore.enableSound ? 'sound-on' : 'sound-off')

const onToggleSound = () => {
	hStore.toggleSound()
}

const onLogout = () => {
	clearSession()
	router.push('/login')
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(AppResizableDropdown, {
    ref_key: "dropdownRef",
    ref: dropdownRef,
    position: "bottom",
    trigger: "click"
  }, {
    activator: _withCtx(() => [
      _createElementVNode("button", {
        type: "button",
        class: "user-trigger",
        title: profile.value?.Name ?? ''
      }, [
        (profile.value?.PhotoLink)
          ? (_openBlock(), _createElementBlock("img", {
              key: 0,
              class: "user-trigger__avatar user-trigger__avatar--img",
              src: _unref(resolvePhotoUrl)(profile.value.PhotoLink),
              alt: ""
            }, null, 8, _hoisted_2))
          : (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(avatarLiter.value), 1))
      ], 8, _hoisted_1)
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", {
          class: "user-dd__item user-dd__item--clickable",
          onClick: onOpenSettings
        }, [
          _createVNode(AppIcon, {
            name: "user",
            width: "18px",
            color: "#FFFFFF",
            class: "user-dd__icon"
          }),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, _toDisplayString(profile.value?.Name || '—'), 1),
            _createElementVNode("div", _hoisted_7, _toDisplayString(profile.value?.Mail || ''), 1)
          ])
        ]),
        _createElementVNode("div", {
          class: _normalizeClass([
					'user-dd__item',
					editingStatus.value ? 'user-dd__item--editing' : 'user-dd__item--clickable'
				]),
          onClick: _cache[2] || (_cache[2] = ($event: any) => (!editingStatus.value && onEditStatus()))
        }, [
          _createVNode(AppIcon, {
            name: "comment",
            width: "18px",
            color: "#FFFFFF",
            class: "user-dd__icon"
          }),
          _createElementVNode("div", _hoisted_8, [
            (!editingStatus.value)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  (profile.value?.Status)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(profile.value?.Status), 1))
                    : (_openBlock(), _createElementBlock("span", _hoisted_10, " Введите статус... "))
                ], 64))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createVNode(AppCustomTextarea, {
                    modelValue: draftStatus.value,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((draftStatus).value = $event)),
                    placeholder: "Статус",
                    "min-height": 80,
                    "max-height": 400,
                    "auto-focus": "",
                    "clear-hint-text": "Очистить статус",
                    onClick: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["stop"]))
                  }, null, 8, ["modelValue"]),
                  _createElementVNode("div", _hoisted_11, [
                    _createVNode(AppButton, {
                      type: "secondary",
                      label: "Отмена",
                      onClick: onCancelStatus
                    }),
                    _createVNode(AppButton, {
                      label: "Сохранить",
                      onClick: onSaveStatus
                    })
                  ])
                ], 64))
          ])
        ], 2),
        _createElementVNode("div", {
          class: "user-dd__item user-dd__item--clickable",
          onClick: onToggleSound
        }, [
          _createVNode(AppIcon, {
            name: soundIconName.value,
            width: "18px",
            color: "#FFFFFF",
            class: "user-dd__icon"
          }, null, 8, ["name"]),
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("span", _hoisted_13, _toDisplayString(soundLabel.value), 1)
          ])
        ]),
        _createElementVNode("div", {
          class: "user-dd__item user-dd__item--clickable",
          onClick: onLogout
        }, [
          _createVNode(AppIcon, {
            name: "logout",
            width: "18px",
            color: "#FFFFFF",
            class: "user-dd__icon"
          }),
          _cache[3] || (_cache[3] = _createElementVNode("div", { class: "user-dd__content" }, [
            _createElementVNode("span", { class: "user-dd__text" }, "Выйти из системы")
          ], -1))
        ])
      ])
    ]),
    _: 1
  }, 512))
}
}

})